// @flow

import {
  RECEIVED_UI_SETTINGS,
  SET_UI_SETTING,
  TOGGLE_UI_SETTING,
} from './constants';

type UiSettings = {
  [uiSetting: string]: any,
};

export type State = UiSettings;


type SetUiSetting = {
  type: typeof SET_UI_SETTING,
  payload: {
    key: string,
    value: any,
  },
};

type ReceivedUiSettings = {
  type: typeof RECEIVED_UI_SETTINGS,
  payload: {
    settings: UiSettings,
  },
};

type ToggleUiSetting = {
  type: typeof TOGGLE_UI_SETTING,
  payload: {
    key: string,
  },
};


export type ActionProps = SetUiSetting | ToggleUiSetting | ReceivedUiSettings;

export default (state: any = {}, action: ActionProps): State => {
  switch (action.type) {
    case SET_UI_SETTING:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    case RECEIVED_UI_SETTINGS:
      return {
        ...state,
        ...action.payload.settings,
      };
    case TOGGLE_UI_SETTING:
      return {
        ...state,
        [action.payload.key]: !state[action.payload.key],
      };
    default:
      return state;
  }
};
